import axios from '@_system/axios/axios.js'
export default {
	path: '/warehousepurchase',
	arrived(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path+'/arrived', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	overtime(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path+'/overtime', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},

	
	
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	statics(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path+'/statics', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/warehousepurchase', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	import(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	export(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}
